
import {
	Component,
	Vue,
	Inject,
	Prop,
	Watch,
} from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import 'viewerjs/dist/viewer.css'
@Component({
	components: {}
})
export default class NewsDetail extends AbpBase {
	userAgent: string = "";
	item: Object = new Object() as any;
	incidentNumber: number = 0;
	screenWidth: number = 0;
	content: string = "";


	isIos() {
		var u = navigator.userAgent.toLowerCase();
		this.userAgent = u;
		if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
			return true;
		}
		return false;
	}
	getNewsByID() {
		var that = this;
		this.$store.dispatch({
			type: 'app/getISCById',
			id: this.incidentNumber
		}).then((res) => {
			that.item = res as any;

			let symptom = res.symptom;
			let reg1 = new RegExp('&quot;', "g");
			symptom = symptom.replace(reg1, "&apos;");
			let reg2 = new RegExp('<o:p>.*</o:p>', "g");
			symptom = symptom.replace(reg2, '');
			let reg3 = new RegExp('<!--(.|[\r\n])*?-->', "g");
			symptom = symptom.replace(reg3, '');
			let reg4 = new RegExp('<!(.|[\r\n])*?>', "g");
			symptom = symptom.replace(reg4, '');
			that.content = symptom;
		})
	}


	@Watch('$route')
	routechange(to: any, from: any) {
		if (to.query.incidentNumber != from.query.incidentNumber) {
			location.reload();
		}
	}
	async created() {
		var that = this;
		that.screenWidth = document.body.clientWidth
		if (this.$route.query.incidentNumber && (this.$route.query.incidentNumber as any) > 0) {
			this.incidentNumber = this.$route.query.incidentNumber as any;
			this.getNewsByID();
		}
	}
	mounted() {
	}
};
